import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./Domain-Hosting.css";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/Domain & Hosting/domain-hosting-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/Domain & Hosting/domain-hosting-img-2.jpg"; // right image

import SEO from '../../seo';

export default function DomainHosting() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
            <SEO
                title="Domain &amp; Hosting | Horizon WebInfo Pvt Ltd"
                description="Elevate Your Online Presence with Top-Notch Domain &amp; Hosting ServicesAt Horizon WebInfo Pvt Ltd, we understand the pivotal role a robust online presence plays in today&#8217;s digital landscape. Your website is not just a platform; it&#8217;s your digital storefront, a gateway to connect with your audience, and a reflection of your brand&#8217;s ethos. To ensure [&hellip;]"
                canonical="https://www.hwplindia.com/service/domain-hosting/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/domain-hosting-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Domain & Hosting</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Domain & Hosting</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section">
                            <p>
                                Elevate Your Online Presence with Top-Notch Domain & Hosting Services.<br />
                                At Horizon Webinfo Pvt. Ltd. we understand the pivotal role a robust online presence plays in today’s digital landscape. Your website is not just a platform; it’s your digital storefront, a gateway to connect with your audience, and a reflection of your brand’s ethos. To ensure your online success, we offer unparalleled domain and hosting services tailored to meet your specific needs.
                            </p>
                            <h3 className='cta-section-business-process it-consult'>Services Offered :</h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Domain Services</h4>
                                <p>
                                    Your domain name is your digital identity, and we assist you in securing a memorable, relevant, and brand-centric domain. Our services include:
                                </p>
                            </section>
                            <section className='domain-p'>
                                <p><span>Domain Name Registration: </span> Choose from a wide array of domain extensions (.com, .net, .org, etc.) and secure your unique online address.</p>
                                <p><span>Domain Transfer & Management: </span> Seamlessly transfer existing domains and manage all domain-related tasks efficiently through our user-friendly interface.</p>
                                <p><span>Domain Privacy Protection: </span> Safeguard your personal information associated with the domain from prying eyes.</p>
                            </section>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Hosting Solutions</h4>
                                <p>
                                    Reliability, speed, and security are at the core of our hosting services. We offer:
                                </p>
                            </section>
                            <section className='domain-p'>
                                <p><span>Shared Hosting: </span> Perfect for startups and small businesses, providing cost-effective hosting solutions without compromising performance.</p>
                                <p><span>VPS Hosting: </span>  Experience enhanced control, flexibility, and dedicated resources with our Virtual Private Servers.</p>
                                <p><span>Dedicated Hosting: </span> For high-traffic websites and enterprises, enjoy an entire server solely dedicated to your website’s needs.</p>
                                <p><span>Managed WordPress Hosting: </span> Optimized servers specifically designed for WordPress, ensuring lightning-fast performance and robust security.</p>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose">
                                <h3>Why Choose Us</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Experience unparalleled uptime and blazing-fast website speeds with our cutting-edge infrastructure and top-tier data centers.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Your website's security is our priority. Benefit from advanced security protocols, regular backups, and proactive monitoring to keep your data safe.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Our expert support team is available round the clock to address any queries or concerns, ensuring a hassle-free experience.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        As your business grows, easily scale your hosting resources to accommodate increased traffic and evolving needs seamlessly.</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section">
                                <h3>Let's Build Your Digital Empire Together!</h3>
                                <p>
                                    Whether you’re launching a new website, migrating an existing one, or seeking reliable domain and hosting solutions, Horizon Webinfo Pvt. Ltd. is your trusted partner. Empower your online journey with our premium services crafted to elevate your digital presence.
                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}